// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Select,
  MenuItem,
  SelectChangeEvent,
  InputLabel,
  FormControl,
} from "@mui/material";
import Icon from "@mui/material/Icon";
import MDButton from "../../../../components/MDButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { get, post } from "requests";
import { useSubmissionStore } from "../../../../models/applications/SubmissionStore";
import InputMask from "react-input-mask";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  states,
  provinces,
  countries,
  getStatesProvinces,
  getStateProvinceLabel,
  getZipPostalLabel,
  validateZipOrPostalCode,
} from "../../../../utils/States";
import { useMerchantContext } from "./MerchantContext";
import MDInput from "components/MDInput";
import moment from "moment";

const MerchantBusinessOwner = () => {
  const {
    owners,
    setOwnersData,
    merchantOwners,
    merchantAndOwners,
    merchantBusinessInfo,
    updateMerchantAndOwners,
    fetchMerchantData,
  } = useSubmissionStore();
  const { clearData, selectedCountry } = useMerchantContext();
  const [open, setOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editUserId, setEditUserId] = useState(null);
  const [ownerName, setOwnerName] = useState("");
  const [ownerList, setOwnerList] = useState(() => owners || []);

  const validationRules = {
    firstName: { required: true, message: "First name is required" },
    lastName: { required: true, message: "Last name is required" },
    title: { required: false },
    address: { required: false, message: "Address is required" },
    city: { required: false, message: "City is required" },
    state: { required: false, message: "State is required" },
    zip: {
      required: false,
      message: "Valid ZIP/Postal code is required",
    },
    socialSecurity: {
      required: false,
      pattern: /^\d{3}-\d{2}-\d{4}$/,
      message: "Valid SSN (XXX-XX-XXXX) is required",
    },
    socialSecurity: {
      required: false,
      pattern: /^\d{3}-\d{2}-\d{4}$/,
      message: "Valid SSN (XXX-XX-XXXX) is required",
    },
    licenseNo: {
      required: false,
      pattern: /^[A-Za-z0-9]*$/,
      message: "Only letters and numbers allowed",
    },
    dob: {
      required: false,
    },
    phoneNumber: {
      required: false,
      pattern: /^\(\d{3}\) \d{3}-\d{4}$/,
      message: "Valid phone number is required",
    },
    email: {
      required: false,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Valid email is required",
    },
    secondaryEmail: {
      required: false,
      pattern: /^([^\s@]+@[^\s@]+\.[^\s@]+)?$/,
      message: "Valid email required",
    },
    secondaryPhone: {
      required: false,
      pattern: /^(\(\d{3}\) \d{3}-\d{4})?$/,
      message: "Valid phone number required",
    },
  };

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    title: "",
    address: "",
    city: "",
    state: "",
    country: "US",
    licenseNo: "",
    zip: "",
    socialSecurity: "",
    dob: "",
    phoneNumber: "",
    email: "",
    secondaryEmail: "",
    secondaryPhone: "",
  });

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    address: false,
    city: false,
    state: false,
    country: false,
    licenseNo: false,
    zip: false,
    socialSecurity: false,
    dob: false,
    phoneNumber: false,
    email: false,
    secondaryEmail: false,
    secondaryPhone: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    socialSecurity: "",
    licenseNo: "",
    dob: "",
    phoneNumber: "",
    email: "",
    secondaryEmail: "",
    secondaryPhone: "",
  });

  const [formValid, setFormValid] = useState(false);

  useEffect(() => {
    if (clearData) {
      setOwnerList([]);
      setOwnerName("");
      setUsers([]);
      resetFormData();
      setMerchantDetails(null);
    }
  }, [clearData]);

  useEffect(() => {
    if (!merchantBusinessInfo?.merchantId) return;
    if (merchantAndOwners?.merchantId === merchantBusinessInfo?.merchantId) {
      updateUIWithUsersData(merchantAndOwners?.users || []);
      setMerchantDetails(merchantAndOwners);
    } else {
      fetchMerchantData(merchantBusinessInfo?.merchantId);
    }
  }, [merchantBusinessInfo, merchantAndOwners]);

  // Silent validation check to enable/disable Save button without showing errors
  useEffect(() => {
    checkFormValidity();
  }, [formData]);

  const checkFieldValidity = (name, value) => {
    const rule = validationRules[name];
    if (!rule) return true;

    if (rule.required && !value) return false;

    if (name === "zip" && value) {
      const country = formData.country || "US";
      return validateZipOrPostalCode(value, country);
    }

    if (value && rule.pattern && !rule.pattern.test(value)) return false;
    if (value && rule.validate && !rule.validate(value)) return false;

    return true;
  };

  const checkFormValidity = () => {
    let isValid = true;

    Object.keys(validationRules).forEach((field) => {
      const fieldValue = formData[field];
      const fieldValid = checkFieldValidity(field, fieldValue);
      isValid = isValid && fieldValid;
    });

    setFormValid(isValid);
    return isValid;
  };

  const validateField = (name, value) => {
    const rule = validationRules[name];
    if (!rule) return true;

    let isValid = true;
    let message = "";

    if (rule.required && !value) {
      isValid = false;
      message = rule.message || `${name} is required`;
    }

    // Special handling for zip/postal code fields
    if (name === "zip" && value) {
      const country = formData.country || "US";
      isValid = validateZipOrPostalCode(value, country);
      if (!isValid) {
        message = country === "CA"
          ? "Valid format: A1A 1A1"
          : "5-digit ZIP code required";
      }
    } else if (value && rule.pattern && !rule.pattern.test(value)) {
      isValid = false;
      message = rule.message || `Invalid ${name}`;
    }

    if (value && rule.validate && !rule.validate(value)) {
      isValid = false;
      message = rule.message || `Invalid ${name}`;
    }

    setErrors((prev) => ({ ...prev, [name]: !isValid }));
    setErrorMessages((prev) => ({ ...prev, [name]: message }));

    return isValid;
  };

  const validateForm = () => {
    let isValid = true;

    Object.keys(validationRules).forEach((field) => {
      const fieldValue = formData[field];
      const fieldValid = validateField(field, fieldValue);
      isValid = isValid && fieldValid;
    });

    setFormValid(isValid);
    return isValid;
  };

  // const fetchMerchantData = async () => {
  //   if (!merchantBusinessInfo?.merchantId) return;
  //   try {
  //     const response = await get(`fetchMerchantAndOwners/${merchantBusinessInfo.merchantId}`);
  //     if (response) {
  //       updateUIWithUsersData(response?.users);
  //       setMerchantDetails(response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching merchant data:", error);
  //   }
  // };

  const handleEdit = (user) => {
    const userData = {
      firstName: user.firstName || "",
      middleName: user.middleName || "",
      lastName: user.lastName || "",
      title: user.title || "",
      address: user.userAddress?.address || "",
      city: user.userAddress?.city || "",
      state: user.userAddress?.state || "",
      country: user.userAddress?.countryCode || "US",
      zip: user.userAddress?.zipCode || "",
      socialSecurity: user.socialSecurityNo || "",
      dob: formatDate(user.dateOfBirth),
      phoneNumber: user.cellPhone || "",
      email: user.emailAddress || "",
      secondaryEmail: user.secondaryEmail || "",
      secondaryPhone: user.secondaryPhone || "",
      licenseNo: user.licenseNo || "",
    };

    setFormData(userData);
    setEditUserId(user.userId);
    setIsEditing(true);
    setOpen(true);

    // Clear any previous errors when opening the edit modal
    setErrors({
      firstName: false,
      lastName: false,
      title: false,
      address: false,
      city: false,
      state: false,
      country: false,
      licenseNo: false,
      zip: false,
      socialSecurity: false,
      dob: false,
      phoneNumber: false,
      email: false,
      secondaryEmail: false,
      secondaryPhone: false,
    });
    setErrorMessages({
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      socialSecurity: "",
      licenseNo: "",
      dob: "",
      phoneNumber: "",
      email: "",
      secondaryEmail: "",
      secondaryPhone: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    setFormData((prevData) => {
      const updatedData = { ...prevData };

      if (name === "zip") {
        const country = prevData.country || "US";
        if (country === "CA") {
          // Canadian postal code: allow letters, digits, and spaces, limit to 7 chars (A1A 1A1)
          newValue = value.replace(/[^A-Za-z0-9\s]/g, "").slice(0, 7).toUpperCase();
        } else {
          // US zip code: only digits, limit to 5
          newValue = value.replace(/\D/g, "").slice(0, 5);
        }
        updatedData[name] = newValue;
      } else {
        updatedData[name] = value;
      }

      // Reset state and zip when country changes
      if (name === "country") {
        updatedData.state = "";
        updatedData.zip = "";
      }

      return updatedData;
    });

    if (validationRules[name]) {
      validateField(name, name === "zip" ? newValue : value);
    }
  };

  const handleSaveOwner = async () => {
    if (!validateForm()) return;
    if (!merchantDetails) return;

    const newOwner = {
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      title: formData.title,
      userAddress: {
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zipCode: formData.zip,
        countryCode: formData.country || "US",
      },
      emailAddress: formData.email,
      secondaryEmail: formData.secondaryEmail,
      cellPhone: formData.phoneNumber,
      secondaryPhone: formData.secondaryPhone,
      dateOfBirth: formatDate(formData.dob),
      socialSecurityNo: formData.socialSecurity,
      licenseNo: formData.licenseNo,
    };

    let updatedUsers = [...users];
    if (isEditing) {
      updatedUsers = users.map((user) =>
        user.userId === editUserId ? { ...user, ...newOwner } : user
      );
    } else {
      updatedUsers.push(newOwner);
    }

    const updatedPayload = {
      ...merchantDetails,
      users: updatedUsers,
      tenantId: Number(localStorage.getItem("tenantId")),
    };
    try {
      await post("merchant/updateOrCreateMerchantAndUsers", updatedPayload);
      setMerchantDetails(null);
      await fetchMerchantData(updatedPayload?.merchantId);
      setOpen(false);
      setIsEditing(false);
      setEditUserId(null);
      resetFormData();
    } catch (error) {
      console.error("Error updating merchant and users:", error);
    }
  };

  const updateUIWithUsersData = (usersList) => {
    setUsers(usersList || []);
  };

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleDeleteOwner = async (userId, index) => {
    const merchant = merchantBusinessInfo || {};
    if (!userId) return;
    try {
      const response = await post("deletePartyUser", {
        userId,
        partyId: merchant?.merchantId,
        tenantId: Number(localStorage.getItem("tenantId")),
      });
      if (response?.result) {
        fetchMerchantData(merchant?.merchantId);
      } else {
        console.error("Failed to delete owner.");
      }
    } catch (err) {
      console.error("Error deleting user:", err);
    }
  };

  const formatDate = (dob) => {
    const parsed = moment(dob, moment.ISO_8601, true);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  };
  const resetFormData = () => {
    setFormData({
      firstName: "",
      middleName: "",
      lastName: "",
      title: "",
      address: "",
      city: "",
      state: "",
      country: "US",
      zip: "",
      socialSecurity: "",
      dob: "",
      phoneNumber: "",
      email: "",
      secondaryEmail: "",
      secondaryPhone: "",
      licenseNo: "",
    });
    setErrors({
      firstName: false,
      lastName: false,
      address: false,
      city: false,
      state: false,
      country: false,
      zip: false,
      socialSecurity: false,
      dob: false,
      phoneNumber: false,
      email: false,
      secondaryEmail: false,
      secondaryPhone: false,
      licenseNo: false,
    });
    setErrorMessages({
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      socialSecurity: "",
      dob: "",
      phoneNumber: "",
      email: "",
      secondaryEmail: "",
      secondaryPhone: "",
      licenseNo: "",
    });
    setFormValid(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
        marginBottom: "12px",
        border: "1px solid #f0f0f0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "16px" }}>
          Merchant Business Owners
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
          {isExpanded && (
            <MDButton variant="gradient" color="primary" onClick={() => setOpen(true)}>
              + Add Owner
            </MDButton>
          )}
          <IconButton onClick={toggleExpand} sx={{ marginLeft: "8px" }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>

      {/* Table */}
      {isExpanded && (
        <TableContainer component={Paper} sx={{ boxShadow: "none", overflowX: "auto" }}>
          <Table aria-label="sticky table">
            <TableHead sx={{ display: "table-header-group", textAlign: "left" }}>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Title
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Address
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Social Security #
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Date of Birth
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  License #
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Email
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Secondary Email
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Phone Number
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                  }}
                >
                  Secondary Phone
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    padding: "8px",
                    paddingLeft: "45px",
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={index} hover sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                  <TableCell
                    sx={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px" }}
                  >
                    <Avatar alt={user.name} src={user.avatar} />
                    <Typography sx={{ fontSize: "14px" }}>
                      {user.firstName} {user.lastName}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>{user.title}</TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>
                    {[
                      user.userAddress?.address,
                      user.userAddress?.city,
                      user.userAddress?.state,
                      user.userAddress?.zipCode,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>
                    {user.socialSecurityNo}
                  </TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>
                    {user.dateOfBirth}
                  </TableCell>

                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>{user.licenseNo}</TableCell>

                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>
                    {user.emailAddress}
                  </TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>
                    {user.secondaryEmail}
                  </TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>{user.cellPhone}</TableCell>
                  <TableCell sx={{ padding: "8px", fontSize: "13px" }}>
                    {user.secondaryPhone}
                  </TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: "flex", marginLeft: "34px" }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                        onClick={() => handleDeleteOwner(user.userId, index)}
                      >
                        <Icon sx={{ color: "error.main", fontSize: "12px" }}>delete</Icon>
                        <Typography
                          sx={{
                            color: "error.main",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginLeft: "5px",
                          }}
                        >
                          DELETE
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                        onClick={() => handleEdit(user)}
                      >
                        <Icon sx={{ color: "primary.main", fontSize: "12px" }}>edit</Icon>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginLeft: "5px",
                          }}
                        >
                          EDIT
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>{isEditing ? "Edit Owner" : "Add Owner"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "8px" }}>
            <Grid item xs={3}>
              <FormControl fullWidth variant="standard" error={errors.country}>
                <InputLabel>Country</InputLabel>
                <Select
                  name="country"
                  size="medium"
                  value={formData.country}
                  sx={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onChange={handleInputChange}
                  onBlur={() => validateField("country", formData.country)}
                >
                  <MenuItem value="US">United States</MenuItem>
                  <MenuItem value="CA">Canada</MenuItem>
                </Select>
                {errors.country && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.country}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={9}></Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="First Name *"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                onBlur={() => validateField("firstName", formData.firstName)}
                error={errors.firstName}
                helperText={errorMessages.firstName}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Middle Name"
                name="middleName"
                value={formData.middleName}
                onChange={handleInputChange}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Last Name *"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                onBlur={() => validateField("lastName", formData.lastName)}
                error={errors.lastName}
                helperText={errorMessages.lastName}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                variant="standard"
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Street Address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                onBlur={() => validateField("address", formData.address)}
                error={errors.address}
                helperText={errorMessages.address}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                onBlur={() => validateField("city", formData.city)}
                error={errors.city}
                helperText={errorMessages.city}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth variant="standard" error={errors.state}>
                <InputLabel>{getStateProvinceLabel(formData.country)} </InputLabel>
                <Select
                  name="state"
                  size="medium"
                  value={formData.state}
                  sx={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                  onChange={handleInputChange}
                  onBlur={() => validateField("state", formData.state)}
                  onOpen={() => setStateDropdownOpen(true)}
                  onClose={() => setStateDropdownOpen(false)}
                  endAdornment={stateDropdownOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                >
                  {getStatesProvinces(formData.country).map((state) => (
                    <MenuItem key={state.short} value={state.value}>
                      {state.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.state && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.state}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label={getZipPostalLabel(formData.country)}
                name="zip"
                value={formData.zip}
                onChange={handleInputChange}
                onBlur={() => validateField("zip", formData.zip)}
                error={errors.zip}
                helperText={errorMessages.zip}
                variant="standard"
                inputProps={
                  formData.country === "CA"
                    ? {
                        inputMode: "text",
                        maxLength: 7,
                      }
                    : {
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 5,
                      }
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Social Security #"
                name="socialSecurity"
                value={formData.socialSecurity}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  const formattedValue = value.replace(
                    /^(\d{3})(\d{0,2})(\d{0,4})$/,
                    (match, p1, p2, p3) => {
                      if (p3) return `${p1}-${p2}-${p3}`;
                      if (p2) return `${p1}-${p2}`;
                      return p1;
                    }
                  );
                  setFormData((prev) => ({ ...prev, socialSecurity: formattedValue }));
                }}
                onBlur={() => validateField("socialSecurity", formData.socialSecurity)}
                error={errors.socialSecurity}
                helperText={errorMessages.socialSecurity}
                variant="standard"
                inputProps={{
                  maxLength: 11,
                }}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Driver's License #"
                name="licenseNo"
                value={formData.licenseNo}
                onChange={(e) => {
                  const value = e.target.value;
                  const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, "");
                  setFormData((prev) => ({ ...prev, licenseNo: alphanumericValue }));
                }}
                onBlur={() => validateField("licenseNo", formData.licenseNo)}
                error={errors.licenseNo}
                helperText={errorMessages.licenseNo}
                variant="standard"
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Date of Birth"
                name="dob"
                type="date"
                value={formData.dob}
                onChange={(e) => {
                  setFormData((prev) => ({ ...prev, dob: e.target.value }));
                }}
                onBlur={() => validateField("dob", formData.dob)}
                error={errors.dob}
                helperText={errorMessages.dob}
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                onBlur={() => validateField("phoneNumber", formData.phoneNumber)}
                error={errors.phoneNumber}
                helperText={errorMessages.phoneNumber}
                variant="standard"
                InputProps={{
                  inputComponent: InputMask,
                  inputProps: { mask: "(999) 999-9999" },
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                onBlur={() => validateField("email", formData.email)}
                error={errors.email}
                helperText={errorMessages.email}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Secondary Email"
                name="secondaryEmail"
                value={formData.secondaryEmail}
                onChange={handleInputChange}
                onBlur={() => validateField("secondaryEmail", formData.secondaryEmail)}
                error={errors.secondaryEmail}
                helperText={errorMessages.secondaryEmail}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Secondary Phone"
                name="secondaryPhone"
                value={formData.secondaryPhone}
                onChange={handleInputChange}
                onBlur={() => validateField("secondaryPhone", formData.secondaryPhone)}
                error={errors.secondaryPhone}
                helperText={errorMessages.secondaryPhone}
                variant="standard"
                InputProps={{
                  inputComponent: InputMask,
                  inputProps: { mask: "(999) 999-9999" },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              resetFormData();
            }}
            sx={{
              backgroundColor: "#333",
              color: "#fff",
            }}
          >
            Cancel
          </Button>
          <MDButton
            variant="gradient"
            color="primary"
            onClick={handleSaveOwner}
            disabled={!formValid}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MerchantBusinessOwner;
